import * as $ from 'jquery';
import 'bootstrap';
import { bookingFormCommon } from "./c005-bookingform-common";

export class rebateMango {
    private bcommon = new bookingFormCommon();
    showMoreStores(): any {
        let _self = this;
        let $showmoreStoresBtn: any = $('.btn-rebate-mango-show-all');
        let $limitStores: any = $('.rebate-mango-container').attr('data-item--showonload');
        let $showItem: any = $('.rebatemango__results .cur_value');
        let $totalStoresItem: any = $('.rebatemango__results .max_value');
        let filterType: any = $('#isRMSearchResult').val();
        if (filterType == 'No') {
            let arrTitle: any = [];
            let arrfilteredresults: any = [];
            $('.rebate-mago-item').each(function () {
                arrTitle.push($(this).attr('data-title'));
            });
            if (arrTitle.length > 0) {
                arrTitle = $.uniqueSort(arrTitle);
                $.each(arrTitle, function (key: any, val: any) {
                    arrfilteredresults.push($('.rebate-mago-item').filter('[data-title="' + val + '"]').filter(':first'));
                });
            }
            if (arrfilteredresults.length > 0) {
                $.each(arrfilteredresults, function (key: any, val: any) {
                    if (key < $limitStores) {
                        val.removeClass('hidden');
                    }
                });
            }
            let $totalStores: any = arrfilteredresults.length;
            let $visiblePartners: any = $('.rebate-mago-item:visible').length;
            $showItem.html($visiblePartners);
            $totalStoresItem.html($totalStores);
        }

        $showmoreStoresBtn.on('click', (e: any) => {
            e.preventDefault();
            let $nextShowItems: any = $('.rebate-mango-container').attr('data-item--showeachclick');
            filterType = $('#isRMSearchResult').val();
            if (filterType == 'No') {
                let arrTitle: any = [];
                let arrfilteredresults: any = [];
                $('.rebate-mago-item').each(function () {
                    arrTitle.push($(this).attr('data-title'));
                });
                if (arrTitle.length > 0) {
                    arrTitle = $.uniqueSort(arrTitle);
                    $.each(arrTitle, function (key: any, val: any) {
                        arrfilteredresults.push($('.rebate-mago-item').filter('[data-title="' + val + '"]').filter(':first'));
                    });
                }
                if (arrfilteredresults.length > 0) {
                    $.each(arrfilteredresults, function (key: any, val: any) {
                        if (key < $limitStores) {
                            val.removeClass('hidden');
                        }
                    });
                }
                let $totalStores: any = arrfilteredresults.length;
                let $shown: any = $('.rebate-mago-item:visible').length + parseInt($nextShowItems);
                if ($shown < $totalStores) {
                    $.each(arrfilteredresults, function (key: any, val: any) {
                        if (key < $shown) {
                            val.removeClass('hidden');
                        }
                    });
                    let $visiblePartners: any = $('.rebate-mago-item:visible').length;
                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                } else {
                    $.each(arrfilteredresults, function (key: any, val: any) {
                        if (key < $totalStores) {
                            val.removeClass('hidden');
                        }
                    });
                    $showmoreStoresBtn.addClass('hide');
                    let $visiblePartners: any = $('.rebate-mago-item:visible').length;
                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                }
            }
            else {
                let $selectedCategory: any = $('.search-category');
                let $searchInput: any = $('#searchName');
                if ($selectedCategory.val() == 'all') {
                    if ($searchInput.val() != '') {
                        let $filteredresults: any = $('*[data-title]').filter(function () {
                            return $(this).attr('data-title').toLowerCase().indexOf($searchInput.val().toLowerCase()) >= 0;
                        });
                        let arrTitle: any = [];
                        let arrfilteredresults: any = [];
                        $filteredresults.each(function () {
                            arrTitle.push($(this).attr('data-title'));
                        });
                        if (arrTitle.length > 0) {
                            arrTitle = $.uniqueSort(arrTitle);
                            $.each(arrTitle, function (key: any, val: any) {
                                arrfilteredresults.push($filteredresults.filter('[data-title="' + val + '"]').filter(':first'));
                            });
                        }
                        let $shownSearch: any = $filteredresults.filter(':visible').length + parseInt($nextShowItems);
                        let $totalStoresSearch: any = arrfilteredresults.length;
                        if ($shownSearch < $totalStoresSearch) {
                            $.each(arrfilteredresults, function (key: any, val: any) {
                                if (key < $shownSearch) {
                                    val.removeClass('hidden');
                                }
                            });
                            let $visiblePartners: any = $filteredresults.filter(':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStoresSearch);
                        } else {
                            $.each(arrfilteredresults, function (key: any, val: any) {
                                if (key < $totalStoresSearch) {
                                    val.removeClass('hidden');
                                }
                            });
                            $showmoreStoresBtn.addClass('hide');
                            let $visiblePartners: any = $filteredresults.filter(':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStoresSearch);
                        }
                    }
                }
                else {
                    if ($searchInput.val() == '') {
                        let $filteredresults: any = $('*[data-category="' + $selectedCategory.val() + '"]');
                        let $shownSearch: any = $filteredresults.filter(':visible').length + parseInt($nextShowItems);
                        let $totalStoresSearch: any = $filteredresults.length;
                        if ($shownSearch < $totalStoresSearch) {
                            $filteredresults.filter(":lt(" + $shownSearch + ")").removeClass('hidden');
                            let $visiblePartners: any = $filteredresults.filter(':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStoresSearch);
                        } else {
                            $filteredresults.filter(":lt(" + $totalStoresSearch + ")").removeClass('hidden');
                            $showmoreStoresBtn.addClass('hide');
                            let $visiblePartners: any = $filteredresults.filter(':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStoresSearch);
                        }
                    }
                    else {
                        let $filteredresults: any = $('*[data-category="' + $selectedCategory.val() + '"][data-title]').filter(function () {
                            return $(this).attr('data-title').toLowerCase().indexOf($searchInput.val().toLowerCase()) >= 0;
                        });
                        let $shownSearch: any = $filteredresults.filter(':visible').length + parseInt($nextShowItems);
                        let $totalStoresSearch: any = $filteredresults.length;
                        if ($shownSearch < $totalStoresSearch) {
                            $filteredresults.filter(":lt(" + $shownSearch + ")").removeClass('hidden');
                            let $visiblePartners: any = $filteredresults.filter(':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStoresSearch);
                        } else {
                            $filteredresults.filter(":lt(" + $totalStoresSearch + ")").removeClass('hidden');
                            $showmoreStoresBtn.addClass('hide');
                            let $visiblePartners: any = $filteredresults.filter(':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStoresSearch);
                        }

                    }

                }
            }
        });
    }

    initCategoryDropdown(): any {
        let _self = this;
        let rebateMangoCat = $('.search-category');
        var getRebateMangoCat = $.Deferred();
        let getRebateMangoCategories: any = ($('[data-get-rebate-mango-categories]').data('get-rebate-mango-categories') != 'null' && $('[data-get-rebate-mango-categories]').data('get-rebate-mango-categories') != '' && $('[data-get-rebate-mango-categories]').data('get-rebate-mango-categories') != undefined) ? $('[data-get-rebate-mango-categories]').data('get-rebate-mango-categories').split('|') : [];
        if (getRebateMangoCategories.length > 0) {
            var listItems = "<option value=''> </option>";
            listItems += "<option value='all'>All</option>";
            for (var i = 0; i < getRebateMangoCategories.length; i++) {
                let categoryItem: any = getRebateMangoCategories[i].split(',');
                if (categoryItem.length > 0) {
                    if (categoryItem[0] != null && categoryItem[1] != null)
                        if (categoryItem[0].toLowerCase() != 'null' && categoryItem[1].toLowerCase() != 'null') {
                            listItems += "<option value='" + categoryItem[0] + "'>" + categoryItem[1] + "</option>";
                        }
                }
            }
            rebateMangoCat.html(listItems);
            rebateMangoCat.selectize({
                onInitialize: function () {
                    let $searchBtn: any = $('.searchRmSubmit');
                    rebateMangoCat[0].selectize.setValue('most-popular');
                    $searchBtn.trigger('click');
                },
                onFocus: function () {
                    rebateMangoCat.parent().find('.booking-form--title').addClass('input-filled');
                    $('.search-category.selectize-control.single .selectize-input').addClass('select-filled');
                },
                onChange: function () {
                    rebateMangoCat.parent().find('.booking-form--title').addClass('input-filled');
                    $('.search-category.selectize-control.single .selectize-input').addClass('select-filled');

                },
                onBlur: function () {
                    let rebateMangoCatChange = rebateMangoCat.find('option:selected').text();
                    if (rebateMangoCatChange == '') {
                        rebateMangoCat.parent().find('.booking-form--title').removeClass('input-filled');
                        $('.search-category.selectize-control.single .selectize-input').removeClass('select-filled');
                    } else {
                        rebateMangoCat.parent().find('.booking-form--title').addClass('input-filled');
                        $('.search-category.selectize-control.single .selectize-input').addClass('select-filled');
                    }
                },
                sortField: 'text'
            });
        }
    }
    getCookie(name: string): any {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        var cookieVal: any;
        if (parts.length == 2) {
            cookieVal = parts.pop().split(";").shift();
            return cookieVal;
        }
    }
    disclaimerPopup(): any {
        let _self = this;
        $('.rebate-mango-store-container .retailer-login--form').click(function () {
            let cookieAccessToken = _self.getCookie("sapphire");
            if (cookieAccessToken && cookieAccessToken !== "undefined") {
                let response: any = _self.isUserAcceptedDisclaimer();
                if (response != null) {
                    if (response.isAccepted.toLowerCase() === 'false') {
                        $.magnificPopup.open({
                            items: {
                                src: '#rm-disclaimer-popup'
                            },
                            type: 'inline',
                            showCloseBtn: false,
                            modal: 'true',
                            midClick: false,
                            enableEscapeKey: false

                        });
                    }
                    else {
                        _self.getShoppingLink();
                    }
                }

            }
            else {
                document.cookie = "rebateToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                window.location.href = $('[data-rm-login-url]').attr('data-rm-login-url');
            }
        });
        $('#rm-disclaimer-popup .btn-rm-disclaimer--cancel').click(function () {
            $('.rebate-mango-store-container .retailer-login--form').magnificPopup('close');
        });
        $('#rm-disclaimer-popup .btn-rm-discalimer--agree').click(function () {
            _self.acceptDisclaimer();
        });

    }
    isUserAcceptedDisclaimer(): any {
        let _self = this;
        var dataParse: any = null;
        let disclaimerDetailsurl: string = $('[data-get-disclaimer-details]').attr('data-get-disclaimer-details');
        $.ajax({
            type: 'GET',
            url: disclaimerDetailsurl,
            async: false,
            success: function (data: any) {
                if (typeof data === 'string') {
                    dataParse = JSON.parse(data);
                }
                else {
                    dataParse = data;
                }
            },
            error: function (error: any) {
                dataParse = null;
            }
        });
        return dataParse;
    }

    acceptDisclaimer(): any {
        let _self = this;
        let disclaimerDetailsurl: string = $('[data-get-disclaimer-details]').attr('data-get-disclaimer-details');
        $.ajax({
            type: 'POST',
            url: disclaimerDetailsurl,
            data: 'true',
            success: function (msg: any) {
                $.magnificPopup.close();
                _self.getShoppingLink();

            }
        });
    }
    redirectUserAfterLogin(): any {
        let _self = this;
        let bcommon = _self.bcommon;
        let urlParams = bcommon.getUrlVars(window.location.href);
        if (urlParams.fromlogin && urlParams.fromlogin === 'true') {
            let response: any = _self.isUserAcceptedDisclaimer();
            if (response != null) {
                if (response.isAccepted.toLowerCase() === 'false') {
                    $.magnificPopup.open({
                        items: {
                            src: '#rm-disclaimer-popup'
                        },
                        type: 'inline',
                        showCloseBtn: false,
                        modal: 'true',
                        midClick: false,
                        enableEscapeKey: false

                    });
                }
                else {
                    _self.getShoppingLink();
                }
            }
        }
    }
    getShoppingLink(): any {
        let _self = this;
        var dataParse: any = null;
        let shoppingLinkurl: string = $('[data-rm-shop-url]').attr('data-rm-shop-url');
        let bcommon = _self.bcommon;
        let urlParams = bcommon.getUrlVars(window.location.href);
        if (urlParams.retailerKey && urlParams.retailerKey !== '') {
            $.ajax({
                type: 'GET',
                url: shoppingLinkurl + '?retailerKey=' + urlParams.retailerKey,
                async: false,
                success: function (data: any) {
                    if (typeof data === 'string') {
                        dataParse = JSON.parse(data);
                    }
                    else {
                        dataParse = data;
                    }
                    if (dataParse != null) {
                        window.open(
                            dataParse.link,
                            '_blank'
                        );
                    }
                },
                error: function (error: any) {
                    dataParse = null;
                }
            });
        }
    }
    searchStores(): any {
        let $searchBtn: any = $('.searchRmSubmit');
        let $selectedCategory: any = $('.search-category');
        let $searchInput: any = $('#searchName');
        let $noResultsMessage = $('.rebatemango-noresults');
        let $showmoreStoresBtn: any = $('.btn-rebate-mango-show-all');
        let $resultCountSpan: any = $('.rebatemango__results .results');
        let $showItem: any = $('.rebatemango__results .cur_value');
        let $totalStoresItem: any = $('.rebatemango__results .max_value');
        let $limitStores: any = $('.rebate-mango-container').attr('data-item--showonload');
        $searchBtn.on('click', (e: any) => {
            $(".rebate-mago-item").addClass('hidden');
            if ($selectedCategory.val() == 'all') {
                if ($searchInput.val() == '') {
                    $('#isRMSearchResult').val('No')
                    $noResultsMessage.addClass('hide');
                    $showmoreStoresBtn.removeClass('hide');
                    $resultCountSpan.removeClass('hide');
                    let arrTitle: any = [];
                    let arrfilteredresults: any = [];
                    $('.rebate-mago-item').each(function () {
                        arrTitle.push($(this).attr('data-title'));
                    });
                    if (arrTitle.length > 0) {
                        arrTitle = $.uniqueSort(arrTitle);
                        $.each(arrTitle, function (key: any, val: any) {
                            arrfilteredresults.push($('.rebate-mago-item').filter('[data-title="' + val + '"]').filter(':first'));
                        });
                    }
                    if (arrfilteredresults.length > 0) {
                        $.each(arrfilteredresults, function (key: any, val: any) {
                            if (key < $limitStores) {
                                val.removeClass('hidden');
                            }
                        });
                    }
                    let $visiblePartners: any = $('.rebate-mago-item:visible').length;
                    let $totalStores: any = arrfilteredresults.length;
                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                }
                else {
                    let $filteredresults: any = $('*[data-title]').filter(function () {
                        return $(this).attr('data-title').toLowerCase().indexOf($searchInput.val().toLowerCase()) >= 0;
                    });
                    if ($filteredresults.length > 0) {
                        let arrTitle: any = [];
                        let arrfilteredresults: any = [];
                        $filteredresults.each(function () {
                            arrTitle.push($(this).attr('data-title'));
                        });
                        if (arrTitle.length > 0) {
                            arrTitle = $.uniqueSort(arrTitle);
                            $.each(arrTitle, function (key: any, val: any) {
                                arrfilteredresults.push($filteredresults.filter('[data-title="' + val + '"]').filter(':first'));
                            });
                        }
                        if (arrfilteredresults.length > 0) {
                            $.each(arrfilteredresults, function (key: any, val: any) {
                                if (key < $limitStores) {
                                    val.removeClass('hidden');
                                }
                            });
                            $noResultsMessage.addClass('hide');
                            $resultCountSpan.removeClass('hide');
                            $showItem.html($filteredresults.filter(':visible').length);
                            $totalStoresItem.html(arrfilteredresults.length);
                            if (arrfilteredresults.length <= $limitStores) {
                                $showmoreStoresBtn.addClass('hide');
                            }
                            else {
                                $showmoreStoresBtn.removeClass('hide');
                            }
                            $('#isRMSearchResult').val('Yes');
                        }
                    }
                    else {
                        $noResultsMessage.removeClass('hide');
                        $showmoreStoresBtn.addClass('hide');
                        $resultCountSpan.addClass('hide');
                    }
                }
            }
            else {
                if ($searchInput.val() == '') {
                    $('*[data-category="' + $selectedCategory.val() + '"]').filter(":lt(" + $limitStores + ")").removeClass('hidden');
                    if ($('*[data-category="' + $selectedCategory.val() + '"]').length > 0) {
                        $noResultsMessage.addClass('hide');
                        $resultCountSpan.removeClass('hide');
                        $showItem.html($('*[data-category="' + $selectedCategory.val() + '"]').filter(":visible").length);
                        $totalStoresItem.html($('*[data-category="' + $selectedCategory.val() + '"]').length);
                        if ($('*[data-category="' + $selectedCategory.val() + '"]').length <= $limitStores) {
                            $showmoreStoresBtn.addClass('hide');
                        }
                        else {
                            $showmoreStoresBtn.removeClass('hide');
                        }
                        $('#isRMSearchResult').val('Yes');
                    }
                    else {
                        $noResultsMessage.removeClass('hide');
                        $showmoreStoresBtn.addClass('hide');
                        $resultCountSpan.addClass('hide');
                    }
                }
                else {
                    let $filteredresults: any = $('*[data-category="' + $selectedCategory.val() + '"][data-title]').filter(function () {
                        return $(this).attr('data-title').toLowerCase().indexOf($searchInput.val().toLowerCase()) >= 0;
                    });
                    $filteredresults.filter(":lt(" + $limitStores + ")").removeClass('hidden');
                    if ($filteredresults.length > 0) {
                        $noResultsMessage.addClass('hide');
                        $resultCountSpan.removeClass('hide');
                        $showItem.html($filteredresults.filter(':visible').length);
                        $totalStoresItem.html($filteredresults.length);
                        if ($filteredresults.length <= $limitStores) {
                            $showmoreStoresBtn.addClass('hide');
                        }
                        else {
                            $showmoreStoresBtn.removeClass('hide');
                        }
                        $('#isRMSearchResult').val('Yes');
                    }
                    else {
                        $noResultsMessage.removeClass('hide');
                        $showmoreStoresBtn.addClass('hide');
                        $resultCountSpan.addClass('hide');
                    }
                }

            }
        });
    }
}

let scope: Element = document.querySelector('.rebate-mango-stores');
if (scope) {
    try {
        let rebatemango = new rebateMango();        
        rebatemango.showMoreStores();
        rebatemango.searchStores();
        rebatemango.initCategoryDropdown();
    } catch (e) { console.error(e); }
}

let scopeStores: Element = document.querySelector('.rebate-mango-stores-detail');
if (scopeStores) {
    try {
        let rebatemango = new rebateMango();
        rebatemango.disclaimerPopup();
        rebatemango.redirectUserAfterLogin();
    } catch (e) { console.error(e); }
}
